const teacherDetailCheck = () => import('@/views/main/reserve/teacher-detail-check/teacher-detail-check.vue')
export default {
  path: '/main/reserve/teacherDetailCheck',
  name: 'teacherDetailCheck',
  component:teacherDetailCheck,
  children: []
}
